export const boldVaccineApprovalNames = (content: string): string => {
    if (!content) {
        return content;
    }

    let result = content.replace(/\bfrom\b/i, 'From');

    if (/<strong[\s>]/i.test(result)) {
        return result;
    }

    result = result.replace(
        /(^|>)(\s*)([^<>]+?)\s+(submitted|uploaded|sent|shared)\b/i,
        (_match, prefix: string, spaces: string, name: string, verb: string) =>
            `${prefix}${spaces}<strong>${name.trim()}</strong> ${verb}`
    );

    result = result.replace(
        /\bFrom\s+([^<>]+?)\s+(for|regarding)\b/,
        (_match, name: string, connector: string) => `From <strong>${name.trim()}</strong> ${connector}`
    );

    result = result.replace(
        /(^|>|\s)(?!<strong>)([^<>]+?)('s)\s+(vaccine|vaccination|record)\b/i,
        (_match, prefix: string, name: string, possessive: string, noun: string) =>
            `${prefix}<strong>${name.trim()}</strong>${possessive} ${noun}`
    );

    result = result.replace(
        /\bfor\s+(?!<strong>)(.+?)\s+on\s+(?=(?:Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec))/i,
        (_match, name: string) => `for <strong>${name.trim()}</strong> on `
    );

    result = result.replace(
        /\bfor\s+(?!<strong>)([^<>]+?)(?=\s+(?:vaccine|approval|record)|[.!?]|$)/i,
        (_match, name: string) => `for <strong>${name.trim()}</strong>`
    );

    return result;
};
